<script>
    import { onMount } from 'svelte';

    import WidgetBox from './WidgetBox.svelte';
    import WordMap from './wordexplorer/WordMap.svelte';
    import ExampleButton from './util/ExampleButton.svelte';
    import { slide, blur } from 'svelte/transition';
    import tippy from "sveltejs-tippy";
    import ComboControl from './util/ComboControl.svelte';

    let grid = [];
    let wordPosLookup = {};

    onMount(async () => {
        const res = await fetch('assets/grid.json');
        grid = await res.json();
        const wordPosRes = await fetch('assets/word-pos.json');
        wordPosLookup = await wordPosRes.json();
    });

    let wordMap;

    let findField = "";

    function inLookup() {
        return wordPosLookup.hasOwnProperty(findField);
    }

    $: {
        if (findField.length > 0 && inLookup() && wordMap) {
            wordMap.jumpTo(wordPosLookup[findField]);
        }
    }

</script>

<style>

    .finder {
        width: 10rem;
        font-size: 0.9rem;
        margin: 0;
        padding: 0.25rem 0.5rem 0.25rem 0.5rem;
    }
    
    .invalid {
        background: repeating-linear-gradient(
            45deg,
            #ddd8,
            #ddd8 5px,
            #eee8 5px,
            #eee8 10px
        );
    }

</style>

<WidgetBox>
    <span slot="title">Explorer</span>
    <span slot="tagline">Investigate an endless field of nonsense</span>

    <div slot="widget" id="word-explorer" transition:slide|local>

        <div class="box dark lev1" style="position: relative; z-index: 1; height: 60vh; margin-left: 0; margin-right: 0;">
            <div class="box purple lev2 light-border" style='height: calc(100% - 0.75rem);'>
                {#if grid.length > 0}
                    <WordMap {grid} bind:this={wordMap}/>
                {:else}
                    <p>loading...</p>
                {/if}
            </div>
        </div>

        <ComboControl>

            <div slot="label">
                <span use:tippy="{{content: 'Some \"real\" words are in the explorer. Type here to find them.'}}">
                <div class="help">&nbsp;</div>&nbsp;SEARCH</span>
            </div>
            
            <div slot="control">
                <input id="wordlist" list="words"
                    placeholder="start typing..."
                    class="box medium light lev2 light-border finder"
                    class:invalid="{!wordPosLookup.hasOwnProperty(findField)}"
                    bind:value={findField}>
            </div>
        
            <div slot="right">
            
                <div class="control-pair" use:tippy="{{content: 'Jump to a random spot'}}">
                    <button class="hovery"
                    style="background-image: url(assets/svg/_randomize-medium-purple.svg);"
                    id="randomize" title="Random location"
                    on:click={() => { findField = ''; wordMap.jump() }}>&nbsp;</button>
                    <label for="randomize">Jump</label>
                </div>
                <datalist id="words">
                    {#if wordPosLookup}
                        {#each Object.keys(wordPosLookup) as item}
                            <option value="{item}">{item}</option>
                        {/each}
                    {:else}
                        <option value="waiting...">waiting...</option>
                    {/if}
                </datalist>
        
            </div>
        
        </ComboControl>
     
    </div>

    <div slot="modalContent">

        <p>The <b>Explorer</b> guides you on a journey through an endless field of nonsense words.</p>

        <h4>How to use it</h4>
        <ul>
            <li>Tap and drag inside the viewer to pan around the field of nonsense.</li>
            <li>Hit <ExampleButton src="assets/svg/_randomize-medium-purple.svg" alt="Random">Jump</ExampleButton>
            to move to a random location.</li>
            <li>There are several thousand "real" words in the grid.
            You can search for these by typing into the <b>Search</b> field.</li>
        </ul>
            
        <h4>Things to try</h4>
        <ul>
            <li>Words that are similar to each other in sound are
                found close to each other on the grid. Try reading out loud down columns or
                across rows or even on the diagonal.</li>
            <li>The field isn't actually endless. It loops around at the edges, so it's more of a
                torus than a field. There are a lot of weird words on this torus though!</li>
        </ul>
            
    </div>

</WidgetBox>